export default __webpack_public_path__ + "static/media/Pelita Grande Std-Regular.fdec232d.otf";